

// import React, { useMemo } from 'react';
// import { Card, CardContent, Typography, Box, useTheme, Stack } from '@mui/material';
// import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// interface SpendAnalysisDataPoint {
//   date: string;
//   spend: number;
//   forecast: number;
// }

// interface SpendAnalysisChartProps {
//   data: SpendAnalysisDataPoint[];
// }

// const legendItems = [
//   { name: 'Spend', color: '#000000' },
//   { name: 'Forecast', color: '#FF8900' },
// ];

// // --- Custom component for the Y-Axis Tick ---
// const CustomYAxisTick = (props: any) => {
//   const { x, y, payload } = props;
//   if (!payload || payload.value === undefined) return null;

//   const value = payload.value;
//   let label;

//   // --- UPDATED: Conditionally format small vs large numbers ---
//   if (value > 0 && value < 1) {
//     label = `$${value.toFixed(2)}`;
//   } else {
//     label = `$${Math.round(value).toLocaleString()}`;
//   }

//   return (
//     <g transform={`translate(${x},${y})`}>
//       <text x={0} y={0} dy={4} textAnchor="end" fill="#00000066" style={{ fontSize: 13, fontFamily: 'Inter' }}>
//         {label}
//       </text>
//     </g>
//   );
// };

// // --- Custom Tooltip Component ---
// const CustomTooltip = ({ active, payload, label }: any) => {
//   if (active && payload && payload.length) {
//     // Validate label (date string)
//     if (typeof label !== 'string' || label === "") {
//         console.error("SpendAnalysis CustomTooltip: Received invalid label for date:", label);
//         return <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter' }}><Typography color="error">Invalid date label</Typography></Card>;
//     }
//     const data = payload[0].payload;
//     const date = new Date(label);

//     if (isNaN(date.getTime())) {
//         console.error("SpendAnalysis CustomTooltip: 'new Date(label)' resulted in Invalid Date for label:", label);
//         return <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter' }}><Typography color="error">Invalid date format</Typography></Card>;
//     }

//     // Validate data object and its properties
//     if (!data || typeof data.tooltipSpend !== 'number' || typeof data.tooltipForecast !== 'number') {
//         console.error("SpendAnalysis CustomTooltip: Invalid or missing data in payload:", data);
//         return <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter' }}><Typography color="error">Invalid data</Typography></Card>;
//     }


//     const formattedDate = `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date)}, ${date.getDate()} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date)} • ${date.getFullYear()}`;

//     return (
//       <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', minHeight: '100px', fontFamily: 'Inter' }}>
//         <Typography sx={{ fontSize: '12px', color: '#C9C9C9', marginBottom: '12px', textAlign: 'center' }}>
//           {formattedDate}
//         </Typography>
//         <Stack spacing={1}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <FiberManualRecordIcon sx={{ color: '#000000', fontSize: '10px', mr: 0.75 }} />
//               <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>Spend</Typography>
//             </Box>
//             <Typography sx={{ fontSize: '13px', fontWeight: '430' }}>
//               {`$${data.tooltipSpend.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
//             </Typography>
//           </Stack>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <FiberManualRecordIcon sx={{ color: '#FF8900', fontSize: '10px', mr: 0.75 }} />
//               <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>Forecast</Typography>
//             </Box>
//             <Typography sx={{ fontSize: '13px', fontWeight: '430' }}>
//               {`$${data.tooltipForecast.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
//             </Typography>
//           </Stack>
//         </Stack>
//       </Card>
//     );
//   }
//   return null;
// };

// const SpendAnalysisChart: React.FC<SpendAnalysisChartProps> = ({ data }) => {
//   const theme = useTheme();

//   const formattedData = useMemo(() => data.map(item => ({
//     date: item.date,
//     value: item.spend,
//     tooltipSpend: item.spend,
//     tooltipForecast: item.forecast
//   })), [data]);

//   // --- UPDATED: More regular and predictable Y-Axis interval calculation ---
//   const { yAxisDomain, yAxisTicks } = useMemo(() => {
//     if (!formattedData || formattedData.length === 0) {
//       return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
//     }

//     const maxSpend = Math.max(...formattedData.map(item => item.value || 0));

//     if (maxSpend === 0) {
//         return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
//     }
    
//     // 1. Find a "nice" upper bound (e.g., round 168 up to 200, or 1.8 up to 2.0)
//     const magnitude = Math.pow(10, Math.floor(Math.log10(maxSpend)));
//     const niceUpperBound = Math.ceil(maxSpend / magnitude) * magnitude;
    
//     // 2. Create 5 evenly spaced ticks (4 intervals) based on the new upper bound
//     const tickCount = 5;
//     const ticks = [];
//     for (let i = 0; i < tickCount; i++) {
//         ticks.push(i * (niceUpperBound / (tickCount - 1)));
//     }

//     return {
//       yAxisDomain: [0, niceUpperBound],
//       yAxisTicks: ticks,
//     };
//   }, [formattedData]);

//   return (
//     <Card elevation={0} sx={{ borderRadius: '16px', height: '400px', width: '100%', fontFamily: 'Inter, sans-serif' }}>
//       <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
//           <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
//             Spend Analysis
//           </Typography>
//           <Stack direction="row" spacing={2.5} alignItems="center">
//             {legendItems.map((item) => (
//               <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
//                 <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//                   {item.name}
//                 </Typography>
//               </Box>
//             ))}
//           </Stack>
//         </Box>
//         <Box sx={{ width: '100%', height: '320px' }}>
//           <ResponsiveContainer width="100%" height="100%">
//             <LineChart data={formattedData} margin={{ top: 10, right: 10, left: -15, bottom: 0 }}>
//               <defs>
//                 <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
//                   <stop offset="0%" stopColor="#CCCCCC" />
//                   <stop offset="35%" stopColor="#000000" />
//                   <stop offset="65%" stopColor="#000000" />
//                   <stop offset="100%" stopColor="#CCCCCC" />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="6 6" stroke="#E4EAF0" horizontal={true} vertical={false} />
//               <XAxis dataKey="date" hide={true} />
//               {/* --- UPDATED: Using dynamic domain and ticks --- */}
//               <YAxis
//                 axisLine={false}
//                 tickLine={false}
//                 domain={yAxisDomain}
//                 ticks={yAxisTicks}
//                 tick={<CustomYAxisTick />}
//               />
//               <Tooltip
//                 cursor={{ stroke: '#CBD5DE', strokeWidth: 1.5, strokeDasharray: '5 5' }}
//                 content={<CustomTooltip />}
//                 wrapperStyle={{ zIndex: 1000 }}
//               />
//               <Line
//                 type="monotone"
//                 dataKey="value"
//                 stroke="url(#lineGradient)"
//                 strokeWidth={2.5}
//                 dot={false}
//                 activeDot={{ r: 6, stroke: 'white', strokeWidth: 2, fill: 'black' }}
//               />
//             </LineChart>
//           </ResponsiveContainer>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };
// export default SpendAnalysisChart;


// import React, { useMemo } from 'react';
// import { Card, CardContent, Typography, Box, useTheme, Stack } from '@mui/material';
// import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// interface SpendAnalysisDataPoint {
//   date: string;
//   spend: number;
//   forecast: number;
// }

// interface SpendAnalysisChartProps {
//   data: SpendAnalysisDataPoint[];
// }

// const legendItems = [
//   { name: 'Spend', color: '#000000' },
//   { name: 'Forecast', color: '#FF8900' },
// ];

// // --- Custom component for the Y-Axis Tick ---
// const CustomYAxisTick = (props: any) => {
//   const { x, y, payload } = props;
//   if (!payload || payload.value === undefined) return null;

//   const value = payload.value;
//   let label;

//   // --- UPDATED: Conditionally format small vs large numbers ---
//   if (value > 0 && value < 1) {
//     label = `$${value.toFixed(2)}`;
//   } else {
//     label = `$${Math.round(value).toLocaleString()}`;
//   }

//   return (
//     <g transform={`translate(${x},${y})`}>
//       <text x={0} y={0} dy={4} textAnchor="end" fill="#00000066" style={{ fontSize: 13, fontFamily: 'Inter' }}>
//         {label}
//       </text>
//     </g>
//   );
// };

// // --- Custom Tooltip Component ---
// const CustomTooltip = ({ active, payload, label }: any) => {
//   if (active && payload && payload.length) {
//     // Validate label (date string)
//     if (typeof label !== 'string' || label === "") {
//         console.error("SpendAnalysis CustomTooltip: Received invalid label for date:", label);
//         return <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter' }}><Typography color="error">Invalid date label</Typography></Card>;
//     }
//     const data = payload[0].payload;
//     const date = new Date(label);

//     if (isNaN(date.getTime())) {
//         console.error("SpendAnalysis CustomTooltip: 'new Date(label)' resulted in Invalid Date for label:", label);
//         return <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter' }}><Typography color="error">Invalid date format</Typography></Card>;
//     }

//     // Validate data object and its properties
//     if (!data || typeof data.tooltipSpend !== 'number' || typeof data.tooltipForecast !== 'number') {
//         console.error("SpendAnalysis CustomTooltip: Invalid or missing data in payload:", data);
//         return <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter' }}><Typography color="error">Invalid data</Typography></Card>;
//     }


//     const formattedDate = `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date)}, ${date.getDate()} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date)} • ${date.getFullYear()}`;

//     return (
//       <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', minHeight: '100px', fontFamily: 'Inter' }}>
//         <Typography sx={{ fontSize: '12px', color: '#C9C9C9', marginBottom: '12px', textAlign: 'center' }}>
//           {formattedDate}
//         </Typography>
//         <Stack spacing={1}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <FiberManualRecordIcon sx={{ color: '#000000', fontSize: '10px', mr: 0.75 }} />
//               <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>Spend</Typography>
//             </Box>
//             <Typography sx={{ fontSize: '13px', fontWeight: '430' }}>
//               {`$${data.tooltipSpend.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
//             </Typography>
//           </Stack>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <FiberManualRecordIcon sx={{ color: '#FF8900', fontSize: '10px', mr: 0.75 }} />
//               <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>Forecast</Typography>
//             </Box>
//             <Typography sx={{ fontSize: '13px', fontWeight: '430' }}>
//               {`$${data.tooltipForecast.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
//             </Typography>
//           </Stack>
//         </Stack>
//       </Card>
//     );
//   }
//   return null;
// };

// const SpendAnalysisChart: React.FC<SpendAnalysisChartProps> = ({ data }) => {
//   const theme = useTheme();

//   const formattedData = useMemo(() => data.map(item => ({
//     date: item.date,
//     value: item.spend,
//     tooltipSpend: item.spend,
//     tooltipForecast: item.forecast
//   })), [data]);

//   // --- UPDATED: More regular and predictable Y-Axis interval calculation ---
//   const { yAxisDomain, yAxisTicks } = useMemo(() => {
//     if (!formattedData || formattedData.length === 0) {
//       return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
//     }

//     const maxSpend = Math.max(...formattedData.map(item => item.value || 0));

//     if (maxSpend === 0) {
//         return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
//     }
    
//     // 1. Find a "nice" upper bound (e.g., round 168 up to 200, or 1.8 up to 2.0)
//     const magnitude = Math.pow(10, Math.floor(Math.log10(maxSpend)));
//     const niceUpperBound = Math.ceil(maxSpend / magnitude) * magnitude;
    
//     // 2. Create 5 evenly spaced ticks (4 intervals) based on the new upper bound
//     const tickCount = 5;
//     const ticks = [];
//     for (let i = 0; i < tickCount; i++) {
//         ticks.push(i * (niceUpperBound / (tickCount - 1)));
//     }

//     return {
//       yAxisDomain: [0, niceUpperBound],
//       yAxisTicks: ticks,
//     };
//   }, [formattedData]);

//   // --- FIX START: DYNAMICALLY CALCULATE Y-AXIS WIDTH ---
//   const yAxisWidth = useMemo(() => {
//     if (!yAxisTicks || yAxisTicks.length === 0) {
//       return 60; // Default width
//     }
//     const maxLabel = `$${Math.round(yAxisTicks[yAxisTicks.length - 1]).toLocaleString()}`;
//     // Simple text width estimation: (character count * font size multiplier) + padding
//     return maxLabel.length * 8 + 10;
//   }, [yAxisTicks]);
//   // --- FIX END ---

//   return (
//     <Card elevation={0} sx={{ borderRadius: '16px', height: '400px', width: '100%', fontFamily: 'Inter, sans-serif' }}>
//       <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
//           <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
//             Spend Analysis
//           </Typography>
//           <Stack direction="row" spacing={2.5} alignItems="center">
//             {legendItems.map((item) => (
//               <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
//                 <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//                   {item.name}
//                 </Typography>
//               </Box>
//             ))}
//           </Stack>
//         </Box>
//         <Box sx={{ width: '100%', height: '320px' }}>
//           <ResponsiveContainer width="100%" height="100%">
//             {/* --- FIX: Corrected chart margin --- */}
//             <LineChart data={formattedData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
//               <defs>
//                 <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
//                   <stop offset="0%" stopColor="#CCCCCC" />
//                   <stop offset="35%" stopColor="#000000" />
//                   <stop offset="65%" stopColor="#000000" />
//                   <stop offset="100%" stopColor="#CCCCCC" />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="6 6" stroke="#E4EAF0" horizontal={true} vertical={false} />
//               <XAxis dataKey="date" hide={true} />
//               <YAxis
//                 axisLine={false}
//                 tickLine={false}
//                 domain={yAxisDomain}
//                 ticks={yAxisTicks}
//                 tick={<CustomYAxisTick />}
//                 // --- FIX: Set the dynamically calculated width on the YAxis ---
//                 width={yAxisWidth}
//               />
//               <Tooltip
//                 cursor={{ stroke: '#CBD5DE', strokeWidth: 1.5, strokeDasharray: '5 5' }}
//                 content={<CustomTooltip />}
//                 wrapperStyle={{ zIndex: 1000 }}
//               />
//               <Line
//                 type="monotone"
//                 dataKey="value"
//                 stroke="url(#lineGradient)"
//                 strokeWidth={2.5}
//                 dot={false}
//                 activeDot={{ r: 6, stroke: 'white', strokeWidth: 2, fill: 'black' }}
//               />
//             </LineChart>
//           </ResponsiveContainer>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };
// export default SpendAnalysisChart;

import React, { useMemo } from 'react';
import { Card, CardContent, Typography, Box, useTheme, Stack } from '@mui/material';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

interface SpendAnalysisDataPoint {
  date: string;
  spend: number;
  forecast: number;
}

interface SpendAnalysisChartProps {
  data: SpendAnalysisDataPoint[];
}

const legendItems = [
  { name: 'Spend', color: '#000000' },
  { name: 'Forecast', color: '#FF8900' },
];

// --- Custom component for the Y-Axis Tick ---
const CustomYAxisTick = (props: any) => {
  const { x, y, payload } = props;
  if (!payload || payload.value === undefined) return null;

  const value = payload.value;
  let label;

  if (value > 0 && value < 1) {
    label = `$${value.toFixed(2)}`;
  } else {
    label = `$${Math.round(value).toLocaleString()}`;
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={4} textAnchor="end" fill="#00000066" style={{ fontSize: 13, fontFamily: 'Inter' }}>
        {label}
      </text>
    </g>
  );
};

// --- SOLUTION: UPDATED Custom Tooltip Component ---
const CustomTooltip = ({ active, payload, label }: any) => {
  // 1. Validate the essential props. If invalid, return null to hide the tooltip.
  if (!active || !payload || !payload.length || typeof label !== 'string' || label === "") {
    // Returning null prevents the tooltip from rendering.
    return null;
  }

  const data = payload[0].payload;
  const date = new Date(label);

  // 2. Validate the date object. Log error for debugging but don't show the user.
  if (isNaN(date.getTime())) {
    console.error("SpendAnalysis CustomTooltip: 'new Date(label)' resulted in Invalid Date for label:", label);
    return null;
  }

  // 3. Validate the data object and its numeric properties.
  if (!data || typeof data.tooltipSpend !== 'number' || typeof data.tooltipForecast !== 'number') {
    console.error("SpendAnalysis CustomTooltip: Invalid or missing data in payload:", data);
    return null;
  }

  // 4. If all validations pass, render the tooltip with the valid data.
  const formattedDate = `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date)}, ${date.getDate()} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date)} • ${date.getFullYear()}`;

  return (
    <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', minHeight: '100px', fontFamily: 'Inter' }}>
      <Typography sx={{ fontSize: '12px', color: '#C9C9C9', marginBottom: '12px', textAlign: 'center' }}>
        {formattedDate}
      </Typography>
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FiberManualRecordIcon sx={{ color: '#000000', fontSize: '10px', mr: 0.75 }} />
            <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>Spend</Typography>
          </Box>
          <Typography sx={{ fontSize: '13px', fontWeight: '430' }}>
            {`$${data.tooltipSpend.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FiberManualRecordIcon sx={{ color: '#FF8900', fontSize: '10px', mr: 0.75 }} />
            <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>Forecast</Typography>
          </Box>
          <Typography sx={{ fontSize: '13px', fontWeight: '430' }}>
            {`$${data.tooltipForecast.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

const SpendAnalysisChart: React.FC<SpendAnalysisChartProps> = ({ data }) => {
  const theme = useTheme();

  const formattedData = useMemo(() => data.map(item => ({
    date: item.date,
    value: item.spend,
    tooltipSpend: item.spend,
    tooltipForecast: item.forecast
  })), [data]);

  const { yAxisDomain, yAxisTicks } = useMemo(() => {
    if (!formattedData || formattedData.length === 0) {
      return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
    }

    const maxSpend = Math.max(...formattedData.map(item => item.value || 0));

    if (maxSpend === 0) {
        return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
    }
    
    const magnitude = Math.pow(10, Math.floor(Math.log10(maxSpend)));
    const niceUpperBound = Math.ceil(maxSpend / magnitude) * magnitude;
    
    const tickCount = 5;
    const ticks = [];
    for (let i = 0; i < tickCount; i++) {
        ticks.push(i * (niceUpperBound / (tickCount - 1)));
    }

    return {
      yAxisDomain: [0, niceUpperBound],
      yAxisTicks: ticks,
    };
  }, [formattedData]);

  const yAxisWidth = useMemo(() => {
    if (!yAxisTicks || yAxisTicks.length === 0) {
      return 60; // Default width
    }
    const maxLabel = `$${Math.round(yAxisTicks[yAxisTicks.length - 1]).toLocaleString()}`;
    return maxLabel.length * 8 + 10;
  }, [yAxisTicks]);

  return (
    <Card elevation={0} sx={{ borderRadius: '16px', height: '400px', width: '100%', fontFamily: 'Inter, sans-serif' }}>
      <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
            Spend Analysis
          </Typography>
          <Stack direction="row" spacing={2.5} alignItems="center">
            {legendItems.map((item) => (
              <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
                <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {item.name}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box>
        <Box sx={{ width: '100%', height: '320px' }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={formattedData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#CCCCCC" />
                  <stop offset="35%" stopColor="#000000" />
                  <stop offset="65%" stopColor="#000000" />
                  <stop offset="100%" stopColor="#CCCCCC" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="6 6" stroke="#E4EAF0" horizontal={true} vertical={false} />
              <XAxis dataKey="date" hide={true} />
              <YAxis
                axisLine={false}
                tickLine={false}
                domain={yAxisDomain}
                ticks={yAxisTicks}
                tick={<CustomYAxisTick />}
                width={yAxisWidth}
              />
              <Tooltip
                cursor={{ stroke: '#CBD5DE', strokeWidth: 1.5, strokeDasharray: '5 5' }}
                content={<CustomTooltip />}
                wrapperStyle={{ zIndex: 1000 }}
              />
              <Line
                type="monotone"
                dataKey="value"
                stroke="url(#lineGradient)"
                strokeWidth={2.5}
                dot={false}
                activeDot={{ r: 6, stroke: 'white', strokeWidth: 2, fill: 'black' }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};
export default SpendAnalysisChart;